import classNames from 'classnames';

import { MAX_NAME_LENGTH } from '../../helpers/validations';
import { PencilFilledIcon } from '../../icons';

import styles from './_index.module.scss';

export interface TitleInputProps {
  autoFocus?: boolean;
  className?: string;
  error?: string;
  icon?: React.ReactElement;
  isDisabled?: boolean;
  onBlur?: (value: string) => void;
  onChange: (value: string) => void;
  placeholder?: string;
  value?: string;
}

const TitleInput = ({
  autoFocus,
  className,
  error,
  icon,
  isDisabled,
  onBlur,
  onChange,
  placeholder,
  value = '',
}: TitleInputProps) => {
  const onKeyDown = (event: React.KeyboardEvent) => {
    const targetElement = event.target as HTMLInputElement;

    if (event.key === 'Enter') {
      onChange(targetElement.value);
      targetElement.blur();
    }
  };

  return (
    <div
      className={classNames(styles['title-input'], className, {
        [styles['has-error']]: error,
        [styles['is-disabled']]: isDisabled,
      })}
    >
      <div className={styles['title-input-wrapper']}>
        <span aria-hidden className={styles['title-input-icon']}>
          {icon || <PencilFilledIcon />}
        </span>
        <input
          autoFocus={autoFocus}
          className={classNames(styles['title-input-field'], {
            [styles['has-error']]: error,
          })}
          data-testid="title-input"
          disabled={isDisabled}
          maxLength={MAX_NAME_LENGTH}
          onBlur={(event) => onBlur?.(event.target.value)}
          onChange={(event) => onChange(event.target.value)}
          onFocus={(event) => event.target.select()}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          type="text"
          value={value}
        />
      </div>
      {error && <p className={styles['title-input-error']}>{error}</p>}
    </div>
  );
};

export default TitleInput;
